import React, { useState } from 'react';
import ResponsiveImage from '../../parts/ResponsiveImage';
import { formatMoney } from '@shopify/theme-currency';
import { rows } from './utils';
import ProductColors from './ProductColors';

const getMetaValue = (meta, key) => {
  let { gwm } = meta;
  if (!gwm) return;
  let rowSpecs = rows.find((item) => item.key === key);
  if (!rowSpecs) return;

  switch (rowSpecs.type) {
    case 'string':
      // console.log(gwm[rowSpecs.data_key]);
      return gwm[rowSpecs.data_key]?.replace(/(?:\r\n|\r|\n)/g, '<br>');

    case 'boolean':
      return gwm[rowSpecs.data_key] ? 'Yes' : 'No';

    default:
      break;
  }
};

let formatCellContent = (cellData) => {
  if (Array.isArray(cellData)) {
    return cellData.map((item) => {
      return <li>{item}</li>;
    });
  }
  return cellData;
};

const ProductComparisonUnit = (props) => {
  const { row, product, handleProductRemoval } = props;
  const { title, handle, image, variants_max_price, variants_min_price, named_tags, meta } = product;
  // console.log(product);

  // console.log(product);
  let indexId = product._tags.filter((item) => item.indexOf('id:') !== -1)?.[0];
  // console.log(indexId);

  switch (row.source) {
    case 'named_tags':
      return <td data-label={row.label}>{formatCellContent(named_tags[row.data_key])}</td>;

    case 'meta':
      return <td data-label={row.label} dangerouslySetInnerHTML={{ __html: getMetaValue(meta, row.key) }}></td>;

    default:
      switch (row.key) {
        case 'header':
          return (
            <td data-label={row.label}>
              <a href={`/products/${product.handle}`}>
                <ResponsiveImage image={image} title={title}></ResponsiveImage>
              </a>
              <h6>
                <a href={`/products/${product.handle}`}>{title}</a>
              </h6>
              <button onClick={() => handleProductRemoval(product.handle)} className="Button" data-style="dark text">
                Remove
              </button>
            </td>
          );

        case 'colors':
          return (
            <td data-label={row.label}>
              <ProductColors indexId={indexId}></ProductColors>
            </td>
          );

        case 'price':
          return (
            <td data-label={row.label}>
              {formatMoney(variants_min_price * 100)} - {formatMoney(variants_max_price * 100)}
            </td>
          );

        default:
          return <td data-label={row.label}>&nbsp;</td>;
          break;
      }
  }
};

export default ProductComparisonUnit;
